import { render, staticRenderFns } from "./zPercentualProjeto.vue?vue&type=template&id=03dc5ac7&scoped=true&"
import script from "./zPercentualProjeto.vue?vue&type=script&lang=js&"
export * from "./zPercentualProjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc5ac7",
  null
  
)

export default component.exports